var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:[("spinner-" + _vm.type)]},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])}
var staticRenderFns = []

export { render, staticRenderFns }